import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Mail, Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[var(--color-text)] text-white" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-33">
          <div data-id="element-34">
            <div className="flex flex-col mb-4" data-id="element-35">
              <div className="flex items-center" data-id="element-36">
                <span className="text-xl font-bold tracking-tight" data-id="element-37">BIG L</span>
                <Heart size={16} className="text-[var(--color-primary)] fill-current mx-0.5" data-id="element-38" />
                <span className="text-xl font-bold tracking-tight" data-id="element-39">VE</span>
              </div>
              <div className="text-xs font-medium text-gray-400 tracking-widest" data-id="element-40">
                FOUNDATION
              </div>
            </div>
            <p className="text-base italic mb-4 text-gray-300" data-id="element-41">
              "Love is not love until you give it away."
            </p>
            <p className="text-sm text-gray-400" data-id="element-42">
              501(c)(3) Nonprofit Organization
            </p>
          </div>

          <div data-id="element-43">
            <h4 className="text-base font-semibold mb-4 uppercase tracking-wide" data-id="element-44">
              Quick Links
            </h4>
            <ul className="space-y-2" data-id="element-45">
              <li data-id="element-46">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-47">
                  Home
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-49">
                  About
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/trips" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-51">
                  Trips
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/donate" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-53">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-54">
            <h4 className="text-base font-semibold mb-4 uppercase tracking-wide" data-id="element-55">
              Get Involved
            </h4>
            <ul className="space-y-2" data-id="element-56">
              <li data-id="element-57">
                <Link to="/donate" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-58">
                  Give
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/trips" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-60">
                  Go
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/get-involved" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-62">
                  Pray
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/get-involved" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-64">
                  Serve
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-65">
            <h4 className="text-base font-semibold mb-4 uppercase tracking-wide" data-id="element-66">
              Connect
            </h4>
            <div className="flex space-x-4 mb-4" data-id="element-67">
              <a href="#" className="text-gray-300 hover:text-[var(--color-primary)] transition-colors" data-id="element-68">
                <Facebook size={20} data-id="element-69" />
              </a>
              <a href="#" className="text-gray-300 hover:text-[var(--color-primary)] transition-colors" data-id="element-70">
                <Instagram size={20} data-id="element-71" />
              </a>
              <a href="#" className="text-gray-300 hover:text-[var(--color-primary)] transition-colors" data-id="element-72">
                <Youtube size={20} data-id="element-73" />
              </a>
              <a href="mailto:info@biglovefoundation.org" className="text-gray-300 hover:text-[var(--color-primary)] transition-colors" data-id="element-74">
                <Mail size={20} data-id="element-75" />
              </a>
            </div>
            <p className="text-sm text-gray-400" data-id="element-76">info@biglovefoundation.org</p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-400" data-id="element-77">
          <p data-id="element-78">
            &copy; {new Date().getFullYear()} Big Love Foundation. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}